module.exports = __webpack_public_path__ + "static/media/insurance-partners-bg.2a772202.jpg";